import { Directive, TemplateRef, ViewContainerRef } from '@angular/core';
import { MOBILE_MEDIA_QUERY } from './responsive-breakpoints';
import { ResponsiveConditionDirective } from './responsive-condition.directive';

@Directive({
  selector: '[mobile]'
})
export class MobileDirective extends ResponsiveConditionDirective {
  constructor(templateRef: TemplateRef<any>, viewContainer: ViewContainerRef) {
    super(templateRef, viewContainer, MOBILE_MEDIA_QUERY);
  }
}
